import * as React from "react";
import { notification } from "antd";
import { setRealtimeToastApi, REALTIME_TOAST_CONFIG } from "@/entities/notification";

/**
 * Mounts the notification instance realtime toasts render through. A hook
 * instance, not the static `notification` API, because only a hook instance
 * accepts `stack.threshold` — the static one stacks only past three toasts,
 * which its global `maxCount: 3` (App.tsx) means it never reaches.
 */
export function RealtimeToastHost() {
  const [api, contextHolder] = notification.useNotification(REALTIME_TOAST_CONFIG);
  React.useEffect(() => {
    setRealtimeToastApi(api);
    return () => setRealtimeToastApi(null);
  }, [api]);
  return contextHolder;
}
